import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-brand-line bg-brand-paper px-4 py-5" data-id="element-174" data-mp="3kqw5io0qf8hp">
      <div className="mx-auto max-w-4xl" data-id="element-175" data-mp="3fym6mihn2y3a">
        <h2 className="mb-0.5 text-center font-display text-[20px] leading-tight sm:text-3xl" data-id="element-176" data-mp="3fxkt87d5hzie">
          What Diesel Technicians Are Saying
        </h2>
        <p className="mb-3 text-center font-cond text-[12px] font-bold uppercase tracking-wide text-brand-carbon sm:text-sm" data-id="element-177" data-mp="3700r6w7grz6q">
          ⭐⭐⭐⭐⭐ 4.9/5 — Verified Buyers
        </p>
        <ul className="space-y-2.5" data-id="element-178" data-mp="2x09vwsb2xg5l">
          {testimonials.map(testimonial => <li key={testimonial.author} data-id="element-179" data-mp="2x2mmtuytf0us">
              <article className="rounded-lg border border-brand-line bg-white p-3 shadow-sm sm:p-4" data-id="element-180" data-mp="2s2i7i89n8c65">
                <div className="mb-1.5 flex gap-0.5" aria-label="5 star rating" data-id="element-181" data-mp="v8dlxn4k8ecx">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} aria-hidden="true" className="h-4 w-4 fill-brand-yellow text-brand-yellow" data-id="element-182" data-mp="qbn7t5cbfsu5" />)}
                </div>
                <p className="mb-2.5 text-[13px] font-medium italic leading-snug text-brand-muted sm:text-[15px]" data-id="element-183" data-mp="h8azlhcfuxst">
                  “{testimonial.text}”
                </p>
                <div className="flex items-center gap-2.5 border-t border-brand-line pt-2.5" data-id="element-184" data-mp="79bols47aq2n">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-yellow font-display text-base text-brand-carbon" data-id="element-185" data-mp="c7dh13nio1qs">
                    {testimonial.author.charAt(0)}
                  </div>
                  <div className="leading-tight" data-id="element-186" data-mp="14xlp22oc95rn">
                    <p className="font-cond text-[14px] font-bold uppercase text-brand-carbon" data-id="element-187" data-mp="q7efkcgb6x33">
                      {testimonial.author}
                    </p>
                    <p className="text-[11px] font-semibold uppercase tracking-wide text-brand-muted" data-id="element-188" data-mp="1ivabvg1yumzc">
                      {testimonial.role} — {testimonial.location}
                    </p>
                  </div>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}